export const COUPON_CATEGORY_LIST = {
	name: '查询当前账号可创建的券种分类列表',
	api: '${BASE}/bcp-coupon-dev/api/B/coupon/getCatoryList',
	doc: 'http://wiki.rt.com:8090/pages/viewpage.action?pageId=20612640',
};

export const FLOOR_LIST = {
	name: '查询当前账号主体下的建筑物楼层列表',
	api: '${BASE}/bcp-basic-data-dev/api/B/lbs/getFloorListByBidAndBuildId',
	doc: 'http://wiki.rt.com:8090/pages/viewpage.action?pageId=20612821',
};

export const SHOP_LIST = {
	name: '查询当前楼层下的商户列表',
	api: '${BASE}/bcp-basic-data-dev/api/B/lbs/getEntityListByBuildIdAndFloorId',
	method: 'post',
	doc: 'http://wiki.rt.com:8090/pages/viewpage.action?pageId=20612823',
};

export const COUPON_ADD = {
	name: '创建优惠券',
	api: '${BASE}/bcp-coupon-dev/api/B/coupon/add',
	method: 'post',
	doc: 'http://wiki.rt.com:8090/pages/viewpage.action?pageId=20611831',
};

export const COUPON_LIST = {
	name: '查询券种列表',
	api: '${BASE}/bcp-coupon-dev/api/B/coupon/list',
	method:'post',
	doc: 'http://wiki.rt.com:8090/pages/viewpage.action?pageId=20611827',
};
export const COUPON_NEW_LIST = {
	name: '查询券种列表_商管短',
	// api: '${BASE}/bcp-coupon-dev/api/B/coupon/list',
	api: '${BASE}/bcp-coupon-dev/api/B/coupon/list/byActivityEntityId',
	method: 'post',
	// doc: 'http://wiki.rt.com:8090/pages/viewpage.action?pageId=20611827',
	doc: 'http://wiki.rt.com:8090/pages/viewpage.action?pageId=26378277',
};

export const COUPON_ANALYSIS = {
	name: '券种统计信息',
	api: '${BASE}/bcp-coupon-dev/api/B/couponInstance/count',
	doc: 'http://wiki.rt.com:8090/pages/viewpage.action?pageId=20612347',
};

export const COUPON_INFO = {
	name: '获取券种详情',
	api: '${BASE}/bcp-coupon-dev/api/B/coupon/info',
	doc: 'http://wiki.rt.com:8090/pages/viewpage.action?pageId=20611837',
};

export const COUPON_INFO_EXTERNAL_CODE = {
	name: '获取券种中的外部券码列表',
	api: '${BASE}/bcp-coupon-dev/api/B/predefinedCoupon/list',
	method: 'post',
	doc: 'http://wiki.rt.com:8090/pages/viewpage.action?pageId=23463138',
};

export const COUPON_LAUNCH = {
	name: '投放券种到活动',
	api: '${BASE}/bcp-coupon-dev/api/B/coupon/putIn',
	method: 'post',
	doc: 'http://wiki.rt.com:8090/pages/viewpage.action?pageId=20611829',
};

export const COUPON_LAUNCH_BATCH = {
	name: '批量投放券种到活动',
	api: '${BASE}/bcp-coupon-dev/api/B/coupon/batch/putIn',
	method: 'post',
	doc: 'http://wiki.rt.com:8090/pages/viewpage.action?pageId=17697478',
};

export const COUPON_LAUNCH_LIST = {
	name: '查询券批列表',
	api: '${BASE}/bcp-coupon-dev/api/B/coupon/batch/list',
	method: 'post',
	doc: 'http://wiki.rt.com:8090/pages/viewpage.action?pageId=20611823',
};

export const COUPON_DISCARD = {
	name: '废弃券种',
	api: '${BASE}/bcp-coupon-dev/api/B/coupon/activeEnd',
	doc: 'http://wiki.rt.com:8090/pages/viewpage.action?pageId=20611833',
};

export const COUPON_ENABLE = {
	name: '启用/暂停券种',
	api: '${BASE}/bcp-coupon-dev/api/B/coupon/status/enabled',
	doc: 'http://wiki.rt.com:8090/pages/viewpage.action?pageId=20611835',
};

export const COUPON_ENTITY_LIST = {
	name: '查询券种下的券码(核销)列表',
	api: '${BASE}/bcp-coupon-dev/api/B/couponInstance/list',
	method: 'post',
	doc: 'http://10.10.11.68:8090/pages/viewpage.action?pageId=20612297',
};

export const COUPON_EFFECTIVE = {
	name: '核销券码',
	api: '${BASE}/bcp-coupon-dev/api/B/instanceWriteOff/writeOff',
	method: 'post',
	doc: 'http://10.10.11.68:8090/pages/viewpage.action?pageId=20611844',
};

export const COUPON_ACTIVITYLIST = {
	name: '注券活动列表',
	api: '${BASE}/bcp-apps/api/B/B/voucher/activity/pagelist',
	method: 'GET',
	doc: 'http://192.168.14.130:8180/doc.html#/%E5%BA%94%E7%94%A8%E5%B8%82%E5%9C%BA/%E6%8F%90%E4%BE%9B%E7%BB%99B%E7%AB%AF%EF%BC%9AB%E7%AB%AF--%E6%B4%BB%E5%8A%A8%E7%9B%B8%E5%85%B3%E6%8E%A5%E5%8F%A3/voucherCouponPageListActivityUsingGET',
};

export const COUPON_INJECTION = {
	name: '券投放',
	api: '${BASE}/bcp-coupon-dev/api/B/coupon/putIn',
	method: 'POST',
	doc: 'http://10.10.11.68:8090/pages/viewpage.action?pageId=20611829',
};



export const BUSINWSSENTITYGROUP = {
	name: '店铺组',
	api: '${BASE}/bcp-basic-data-dev/api/B/businessEntityGroup/list',
	method: 'post',
	doc: 'http://10.10.11.68:8090/pages/viewpage.action?pageId=26378998',
};

export const AUDITREJECTANDPASS = {
	name: '劵批审核驳回/通过',
	api: '${BASE}/bcp-coupon-dev/api/B/coupon/audit',
	method: 'post',
	doc: 'http://10.10.11.68:8090/pages/viewpage.action?pageId=26378267',
};
